<script setup lang="ts">
import InputControl from './input-control.vue';
import LabelBox from './label-box.vue';

const props = defineProps<{
    id?: string;
    name?: string;
    label?: string | boolean;
    labelClass?: string;
    controlClass?: string;
}>();
</script>
<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>
<template>
    <LabelBox v-slot="{nameprops}" v-bind="props">
        <InputControl v-bind="{ ...nameprops, ...$attrs}" />
    </LabelBox>
</template>
